import React from 'react';
import Hero from '../../components/hero/Hero';
import ProductsSection from '../../components/products/ProductsSection';
import ServicesSection from '../../components/services/ServicesSection';
import PricingSection from '../../components/pricing/PricingSection';
import ContactSection from '../../components/contact/ContactSection';
import { Seo } from '../../components/Seo';
import { useMarket } from '../../context/MarketContext';

const Home: React.FC = () => {
  const { market } = useMarket();

  return (
    <>
      <Seo
        title={
          market === 'US'
            ? 'Cimmple | Cloud Operating System for Machine Shops'
            : 'Cimmple | Pharmacy & Machine Shop Software'
        }
        description={
          market === 'US'
            ? 'CimmpleFlow is a modern cloud operating system for machine shops that includes a complete manufacturing ERP—plus CimmplePay payroll.'
            : 'CimmpleRx for pharmacies and CimmpleFlow—a modern cloud operating system for machine shops—built for Indian businesses.'
        }
      />
      <Hero />
      <ProductsSection />
      <PricingSection />
      <ServicesSection />
      <ContactSection />
    </>
  );
};

export default Home;
